import { Col, Container, Row } from "react-bootstrap";
import { SideNav } from "../shared-components/side-nav";
import {
  Button,
  Card,
  Group,
  IconHelp,
  IconInfo,
  LogoHp,
  Modal,
  Select,
  TextBox,
  Tooltip,
  useToast,
} from "@veneer/core";
import "./create-new-case.scss";
import React, { useEffect, useState } from "react";
import Modall from "../modal/modal";
import {
  GET_Display_NonSerializedProducts,
  OnPageLoad_POST,
  POST_CALL_IS_SERVICE,
} from "../../../services";
import { apiGet, apiGetWithHeader, apiPost } from "../../../services/service";
import { Option, ModalData } from "../../../services/typedefine";
import { useLocation, useNavigate } from "react-router-dom";
import { HelpModalPopup } from "../shared-components/modal-popup/help-modal-popup";
import { useTranslation } from "react-i18next";
import { HpLogo } from "../shared-components/hp-logo/hp-logo";

export const CreateNewCase = () => {
  const [openn, setOpenn] = React.useState<boolean>(false);
  // const [openPopUp, setOpenPopUp] = React.useState<boolean>(true);
  const [value, setValue] = React.useState<any>();
  const [value2, setValue2] = React.useState<any>();
  const [value3, setValue3] = React.useState<any>();
  const [isDisabledbtn1, setDisabledbtn1] = React.useState<boolean>(true);
  const [isDisabledbtn2, setDisabledbtn2] = React.useState<boolean>(true);
  const [isDisabledbtn3, setDisabledbtn3] = React.useState<boolean>(true);
  const [dropdownOption, setDropdownOption] = useState<Option[]>([]);
  const [polyProductSeries, setPolyProductSeries] = React.useState<any[]>([]);
  // const [loading, setLoading] = useState<boolean>(true);
  const [selectedValue, setSelectedValue] = useState(["-1"]);
  const [selectedProductSeries, setSelectedProductSeries] = useState([]);

  const [productSeries, setProductSeries] = useState(["-1"]);

  const [isPoly, setIsPoly] = useState<boolean>(false);
  const [modalData, setModalData] = useState<ModalData | null>(null);
  const [error, setError] = useState<boolean>(false);
  const [productName, setProductName] = useState(["-1"]);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { addToast } = useToast();
  const [open, setOpen] = useState(false);
  function handleCallBack() {
    setOpen(true);
  }

  const popupHeader = () => {
    return (
      <p className="popup-header">
        <HpLogo></HpLogo>
        <span className="ml-2">
          {t("HPI.MainHomePage.SubmitnewCase.NewCase", {
            defaultValue: "Create a new case",
          })}
        </span>{" "}
      </p>
    );
  };

  const handleTextValue = (value: string): void => {
    setValue(value);
    setError(false);
    if (!value || value.trim().length === 0) {
      setDisabledbtn1(true);
    } else {
      setDisabledbtn1(false);
    }
  };
  const handleTextValue2 = (value: string): void => {
    setValue2(value);
    if (!value || value.trim().length === 0) {
      setDisabledbtn2(true);
    } else {
      setDisabledbtn2(false);
    }
  };
  const handleTextVersion = (value: string): void => {
    setValue3(value);
  };

  const handleChange = async () => {
    sessionStorage.setItem("isPoly", "false");
    if (!value) {
      addToast({
        text: "Use serial number must have value",
        type: "warning",
        timeout: 15,
        id: 1,
      });
      return false;
    }
    const filteredData: ModalData = {
      serialNumber: value.trim(),
      type: "Serial Number",
    };
    try {
      let payload = {
        serviceurl: `getentitlementbyserialnumber/${value.trim()}/us`,
        
        
      };
      const response = await apiPost(POST_CALL_IS_SERVICE, payload);
      const assest = JSON.parse(response.data.ISResponse).Assets;
      if (assest?.length > 0) {
        for (let i = 0; i < assest.length; i++) {
          const { Product, licenseKey } = assest[i];
          if (licenseKey) {
            sessionStorage.setItem("licenseKey", licenseKey);
          }
          if (Product?.ProductLineCode) {
            const { ProductLineCode } = Product;
            if (["NL", "NG", "NI", "NJ", "NK"].includes(ProductLineCode)) {
              sessionStorage.setItem("isPoly", "true");
              if (["NL", "NG"].includes(ProductLineCode)) {
                sessionStorage.setItem("isRMA", "true");
                break;
              }
            }
          }
        }
      }
      if (assest?.length <= 0) {
        setOpenn(false);
        setError(true);
      } else if (assest.length === 1) {
        const url = `ainfo=${assest[0].AssertSerialNumber}&pno=${assest[0]?.Product?.ProductId}`;
        navigate(`/case-match?${url}`);
      } else {
        setOpenn(true);
      }
    } catch {
      console.error("erorr in PageLoad Asset data");
    }
    setModalData(filteredData);
  };
  const handleChange2 = () => {
    sessionStorage.setItem("isPoly", "false");

    if (!value2) {
      addToast({
        text: "Account Information  must have value",
        type: "warning",
        timeout: 15,
        id: 1,
      });
      return false;
    }
    const filteredData: ModalData = {
      accountInfo: value2.trim(),
      type: "Account Information",
    };
    setModalData(filteredData);
    setOpenn(true);
  };

  const onClear = () => {
    setSelectedValue([]);
    setProductName(["-1"]);
    setProductSeries(["-1"]);
    setDisabledbtn3(true);
    setIsPoly(false);
    setValue3("");
  };
  const onClearPolyProductSeries = () => {
    setDisabledbtn3(true);
    setProductSeries(["-1"]);
  };
  const handlepopupEvent = (state: boolean) => {
    setOpenn(!state);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      try {
        let payload = {
          contactid: "85680c15-7814-e711-80fc-5065f38ad971",
          accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
          tabid: "Favouritecases",
          submittedbyme: false,
          
          
        };
        let payload2 = {
          serviceurl: `getentitlementbyserialnumber/${value}/us`,
          
          
        };
        const [res1, res2, res3] = await Promise.all([
          apiGetWithHeader(GET_Display_NonSerializedProducts),
          apiPost(OnPageLoad_POST, payload),
          apiPost(POST_CALL_IS_SERVICE, payload2),
        ]);
        const rawData1 = res1.data?.NonSerializedProducts;
        if (rawData1) {
          const Dropdown_Value = JSON.parse(
            res1.data?.NonSerializedProducts.replace(/I"/g, '"').replace(
              /I/g,
              ""
            )
          );

          const formattedOption: Option[] = JSON.parse(
            res1.data.NonSerializedProducts
          ).map((item: any) => ({
            label: item.Value,
            value: item.Key,
          }));
          formattedOption.unshift({ label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" });
          setDropdownOption(formattedOption);
        } else {
          console.error("No Data found For Non Serialized Products ");
        }
        const rawData2 = res1.data?.NonSerializedProducts;
        if (rawData2) {
          const Dropdown_Value = JSON.parse(
            res2.data.polyProductSeries.replace(/I"/g, '"').replace(/I/g, "")
          );

          const formattedOption: Option[] = JSON.parse(
            res2.data.polyProductSeries
          ).map((item: any) => ({
            label: item.Value,
            value: `${item.Key}`,
            AssetGUID: item.AssetGUID
          }));
          formattedOption.unshift({ label: t(
            "HPI.Dropdown.DefaultText",  { defaultValue: "Please select" }
          ), value: "-1" });
          setPolyProductSeries(formattedOption);
        } else {
          console.error("No Data found For Poly Product Series API ");
        }

        sessionStorage.setItem("isPoly", "false");
        sessionStorage.setItem("isRMA", "false");
        sessionStorage.setItem("licenseKey", "");

        const response = res3?.data?.ISResponse;
        const Assets = response?.Assets;

        if (Assets?.length > 0) {
          for (let i = 0; i < Assets.length; i++) {
            const { Product, licenseKey } = Assets[i];
            if (licenseKey) {
              sessionStorage.setItem("licenseKey", licenseKey);
            }
            if (Product?.ProductLineCode) {
              const { ProductLineCode } = Product;
              if (["NL", "NG", "NI", "NJ", "NK"].includes(ProductLineCode)) {
                sessionStorage.setItem("isPoly", "true");
                if (["NL", "NG"].includes(ProductLineCode)) {
                  sessionStorage.setItem("isRMA", "true");
                  break;
                }
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching Dropdown Data:", error);
      }
    }
    fetchMyAPI();
  }, []);
  const handleOkClick = (): void => {
    if (selectedValue && selectedProductSeries) {
      const selectedKey = dropdownOption.find(
        (option: any) => option.label === selectedValue
      )?.value;

      const selectedPolyKey = polyProductSeries.find(
        (option: any) => option.label === selectedProductSeries
      )?.AssetGUID;

      const uri = `pinfo=${selectedKey}&assetid=${selectedPolyKey}`;
      sessionStorage.setItem("Productseries", JSON.stringify(selectedProductSeries));
      sessionStorage.setItem("Version", value3);

      navigate(`/create-case?${uri}`);

    } else {
      const selectedKey = dropdownOption.find(
        (option: any) => option.label === selectedValue
      )?.value;
      const selectedPolyKey = undefined;
      const uri = `pinfo=${selectedKey}&assetid=${selectedPolyKey}`;
      navigate(`/create-case?${uri}`);
    }
  };

  const handleSelectChange = (selectedOption: any) => {
    setSelectedValue(selectedOption.label);
    setProductName([selectedOption.value]);
    setProductSeries(["-1"]);
    setValue3("");

    if (selectedOption.label === "Poly") {
      setIsPoly(true);
      sessionStorage.setItem("isPoly", "true");
      setDisabledbtn3(true);
    } else {
      setIsPoly(false);

      if (selectedOption.value !== "-1") {
        setDisabledbtn3(false);
      } else {
        setDisabledbtn3(true);
      }
    }
  };
  const handleProductSeriesChange = (selectedOption: any) => {
    setSelectedProductSeries(selectedOption.label);
    setProductSeries([selectedOption.value]);

    if (selectedOption.label) {
      setIsPoly(true);
      if (selectedOption.value !== "-1") {
        setDisabledbtn3(false);
      } else {
        setDisabledbtn3(true);
      }
    } else {
      setIsPoly(true);
      setDisabledbtn3(true);
    }
  };

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Container fluid>
      <div className="craete-new-case">
        <div className="body-section">
          <div className="heading-container">
            <h3>
              {t("HPI.MainHomePage.SubmitnewCase.NewCase", {
                defaultValue: "Create a new case",
              })}
            </h3>
            <p>
              {t("HPI.MainHomePage.SubmitnewCase.Note", {
                defaultValue:
                  "Submit and manage support cases for hardware and software products using a serial number, a valid warranty, HP extended warranty or support agreement.",
              })}
            </p>
          </div>
          <Container>
            {" "}
            <Row>
              <Col className="inner-container">
                <Col md={12} className="search-container">
                  <Card
                    background="transparent"
                    border="outlined"
                    className="card-container"
                    content={
                      <div className="content">
                        <Row>
                          <Col md={8}>
                            <label className="label">
                              {t("HPI.MainHomePage.SubmitnewCase.serialNumer", {
                                defaultValue: "Use serial number",
                              })}{" "}
                              <span className="supporting-text">
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.recommended",
                                  { defaultValue: "(Recommended)" }
                                )}
                                <HelpModalPopup
                                  align={"start"}
                                  id={"modal-popup"}
                                  show={open}
                                  onClose={() => setOpen(false)}
                                  title={popupHeader()}
                                  callback={handleCallBack}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: t("HPI.MainPage.DownloadLink", {
                                        defaultValue: `<p><a target=\"_blank\" href=\"https://support.hp.com/us-en/document/ish_2039298-1862169-16\">Click here for tips on finding your serial number</a></p>`,
                                      }),
                                    }}
                                  ></div>
                                </HelpModalPopup>
                              </span>
                            </label>
                            <div className="new-case-input-container">
                              <TextBox
                                //label
                                className="label-small"
                                placeholder={t(
                                  "HPI.MainHomePage.EnterSerialNumber",
                                  { defaultValue: "Enter serial number" }
                                )}
                                separateLabel
                                onChange={handleTextValue}
                                value={value}
                              />

                              <Button
                                disabled={isDisabledbtn1}
                                small
                                className="ml-2"
                                onClick={handleChange}
                              >
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.btnCreateCase",
                                  { defaultValue: "Create Case" }
                                )}
                              </Button>
                            </div>
                            <p className="label-small">
                              <IconInfo size={20} filled color="#666" />
                              <span className="ex-text">
                                {t("HPI.MainHomePage.SubmitnewCase.example", {
                                  defaultValue: 'Example: "HU265BM18V"',
                                })}
                              </span>
                            </p>
                            {error && (
                              <p className="Error_Message">
                                {t(
                                  "HPI.MainHomePage.EnterValidSerialNumberError",
                                  {
                                    defaultValue:
                                      "Serial number provided is not recognize. Please click on the (?) for guidance to find the Serial Number or click on the check box below to find a product, software, or subscription.",
                                  }
                                )}
                              </p>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col md={8}>
                            <div className="new-case-input-container">
                              <TextBox
                                label={t(
                                  "HPI.MainHomePage.SubmitnewCase.information",
                                  {
                                    defaultValue: "Or, use account information",
                                  }
                                )}
                                className="label-small"
                                placeholder={t("HPI.MainHomePage.EnterCWInfo", {
                                  defaultValue:
                                    "Enter contract or warranty information",
                                })}
                                separateLabel
                                onChange={handleTextValue2}
                                value={value2}
                              />
                              <span className="supporting-text"></span>
                              <Button
                                disabled={isDisabledbtn2}
                                small
                                className="ml-2"
                                onClick={handleChange2}
                              >
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.btnCreateCase",
                                  { defaultValue: "Create Case" }
                                )}
                              </Button>
                            </div>
                            <p className="label-small">
                              <IconInfo size={20} filled color="#666666" />
                              <span className="ex-text">
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.serviceagrement",
                                  {
                                    defaultValue:
                                      "(Service agreement ID/ Care Pack ID)",
                                  }
                                )}
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col md={8}>
                            <div className="d-flex align-items-center">
                              <p className="mb-0 ">
                                {t("HPI.MainHomePage.SearchProductByName", {
                                  defaultValue:
                                    "My product or subscription service does not have a serial number (example: Remote Graphics Software, Web Printsmart Plus, Instant Ink)",
                                })}
                              </p>
                            </div>
                            <div className="new-case-input-container mt-2">
                              <Select
                                options={dropdownOption}
                                id="select-usage"
                                label={t(
                                  "HPI.MainHomePage.SubmitnewCase.SearchProduct",
                                  { defaultValue: "Search by product name" }
                                )}
                                value={productName}
                                placement="bottom"
                                helperTextVisibility="auto"
                                onChange={handleSelectChange}
                                onClear={onClear}
                                separateLabel
                              />
                              <Button
                                disabled={isDisabledbtn3}
                                small
                                className="ml-2"
                                onClick={handleOkClick}
                              >
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.btnCreateCase",
                                  { defaultValue: "Create Case" }
                                )}
                              </Button>
                            </div>

                            <p className="label-small">
                              <IconInfo size={20} filled color="#666" />
                              <span className="ex-text">
                                {t(
                                  "HPI.MainHomePage.SubmitnewCase.SearchProductExample",
                                  {
                                    defaultValue:
                                      "Example: Remote Graphics Software, Web Printsmart Plus, Instant Ink",
                                  }
                                )}
                              </span>
                            </p>
                          </Col>
                        </Row>
                        {isPoly && (
                          <Row>
                            <Col>
                              <Select
                                options={polyProductSeries}
                                id="select-usage"
                                label={t('HPI.MainHomePage.Productseries',{defaultValue:'Product Series'})}
                                required
                                placement="bottom"
                                helperTextVisibility="auto"
                                value={productSeries}
                                onChange={handleProductSeriesChange}
                                onClear={onClearPolyProductSeries}
                                separateLabel
                                className="textbox"
                              />
                            </Col>
                            <Col>
                              <TextBox
                                label={t('HPI.MainHomePage.Version',{defaultValue:'Version'})}
                                className="textbox"
                                separateLabel
                                onChange={handleTextVersion}
                                value={value3}
                                placeholder={t('HPI.MainHomePage.Placeholder.EnterVersion',{defaultValue:'Enter version'})}
                              />
                            </Col>
                          </Row>
                        )}
                      </div>
                    }
                  />
                </Col>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Modall
        modalState={openn}
        handlepopupModal={() => handlepopupEvent(openn)}
        value={modalData}
      />
    </Container>
  );
};
